module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABSElEQVRYhe1Y7Q6DIAy8Lntv8cm7HwZHkPHVQ1z0kiVTQe7ohy3AgwcmSO9EVU2/UCT9YJtTXE+kjdK7aXR+YQUA51xxTI2QWlAEiIjmiHv4MSKiLBEv6wtqyYdwzmVdrQUmAT3kPVgizBaYDYsfHnZ/WZb9/7quxfvAZokwHlqzENUCKdI58gzQXah251kYEgMx2VHkgUECwp1PXTNBF1ATyExQBaTIjxZhKuYsHzLgmEKByWl0BkwCVFUspQSjoDNboEcEizxAKqdVVWr6Af/scv0A8CVl7chaQRPgMYJkDvfOQleA2YVCnz/bfQBCS6mq4n+hGFbPWwLVhWZYgJ6FQoTHJylXi63UswEmAbHbxARColHfu1/H99FYYJot8IvYWfj7NGrOQiwi3Rx6J/rT6VwM9ARxa0NDP15vWjwRM7fryB7Mxgc/E87JllOorgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IESTOP.png
// module id = 77
// module chunks = 0